/*
 * Product-card hover video.
 * When a product card contains a Shopify-hosted video (rendered by
 * snippets/product-media-hover.liquid), fade into the muted, looped, inline
 * video on hover / keyboard focus (desktop) or on tap of the discreet control
 * (touch). Only one clip plays at a time; clips load lazily on first activation
 * and pause when scrolled out of view. Reduced-motion users never see autoplay.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var current = null; // the single video currently allowed to play

  function loadSources(video) {
    if (video.getAttribute('data-loaded')) return;
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
    }
    video.setAttribute('data-loaded', '1');
    try { video.load(); } catch (e) {}
  }

  function stop(video) {
    if (!video) return;
    try { video.pause(); } catch (e) {}
    var card = video.closest('[data-hover-video]');
    if (card) card.classList.remove('is-playing');
    if (current === video) current = null;
  }

  function play(video) {
    if (!video || reduceMotion) return;
    if (current && current !== video) stop(current);
    loadSources(video);
    var card = video.closest('[data-hover-video]');
    var promise = video.play();
    if (promise && typeof promise.then === 'function') {
      promise.then(function () {
        if (card) card.classList.add('is-playing');
        current = video;
      }).catch(function () {
        if (card) card.classList.remove('is-playing');
      });
    } else {
      if (card) card.classList.add('is-playing');
      current = video;
    }
  }

  function initCard(card) {
    var video = card.querySelector('[data-hover-video-el]');
    if (!video) return;
    var toggle = card.querySelector('[data-hover-video-toggle]');

    if (canHover && !reduceMotion) {
      card.addEventListener('mouseenter', function () { play(video); });
      card.addEventListener('mouseleave', function () { stop(video); });
      card.addEventListener('focusin', function () { play(video); });
      card.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!card.contains(document.activeElement)) stop(video);
        }, 0);
      });
    }

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (card.classList.contains('is-playing')) {
          stop(video);
        } else {
          play(video);
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && card.classList.contains('is-playing')) {
            stop(video);
          }
        });
      }, { threshold: 0.12 });
      io.observe(card);
    }
  }

  function init() {
    var cards = document.querySelectorAll('[data-hover-video]');
    for (var i = 0; i < cards.length; i++) initCard(cards[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pagehide', function () { stop(current); });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(current);
  });
})();
